import(/* webpackMode: "eager" */ "C:\\Users\\danie\\Desktop\\Landing\\node_modules\\next\\dist\\client\\app-dir\\link.js");
